import { render } from "./SaleCustomersToolbar.vue?vue&type=template&id=0853c5c6&scoped=true"
import script from "./SaleCustomersToolbar.vue?vue&type=script&lang=js"
export * from "./SaleCustomersToolbar.vue?vue&type=script&lang=js"

import "./SaleCustomersToolbar.vue?vue&type=style&index=0&id=0853c5c6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0853c5c6"]])

export default __exports__